<template>
    <a-popover :placement="placement" :trigger="trigger" :overlayClassName="['supsis-popover', className].flat().join(' ')">
        <template #content>
            <slot name="popover-content" />
        </template>
        <slot name="content" />
    </a-popover>
</template>
<script>

import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "Popover",
    components: { SupsisButton },
    props: {
        className: {
            type: String,
            default: "",
        },
        trigger: {
            type: String,
            default: "click",
            enum: ['hover', 'focus', 'click', 'contextmenu'],
        },
        placement: {
            type: String,
            default: "right",
            enum: ["top", "left", "right", "bottom", "topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"],
        },
    },
};
</script>
<style lang="scss">
.supsis-popover {
    padding-left: 0 !important;

    .ant-popover-arrow {
        display: none !important;
    }

    .ant-popover-inner {
        box-shadow: none !important;
        border: 1px solid var(--border-neutral-default)
    }

    .ant-popover-inner-content {
        box-shadow: none !important;
        padding: 0 !important;
    }
}
</style>
